import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  rootbox: {
    background: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
}));
